import React, { Component } from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import RaisedButton from "material-ui/RaisedButton";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import TextField from "material-ui/TextField";
import { ResponsiveAd } from "components/ui/ads";

class component extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.handleClose.bind(this);
  }

  componentDidMount() {
    clearTimeout(this.timer1_id);
    this.timer1_id = setTimeout(() => {
      this.open();
    }, this.props.delay);
  }

  componentWillUnmount() {
    clearTimeout(this.timer1_id);
  }

  handleClose = () => {
    this.setState(prev => {
      return {
        open: false
      };
    });
  };

  open = () => {
    this.setState(prev => {
      return {
        open: true
      };
    });
  };

  render() {
    const actions = [
      <FlatButton key="cancel-btn" label="Not now" primary={true} onClick={this.handleClose} />,
      <FlatButton key="submit-btn" label="Get Subscription" primary={true} href="/shop" />
    ];
    return (
      <Dialog title="Consider Supporting Pocketmod" actions={actions} modal={false} open={this.state.open} onRequestClose={this.handleClose}>
        <form>
          <ResponsiveAd />
          <p>To use Pocketmod ad free, Please consider subscribing.</p>
        </form>
      </Dialog>
    );
  }
}

component.propTypes = {
  delay: PropTypes.number
};

component.defaultProps = {
  delay: 1000 * 30
};

export default component;



// WEBPACK FOOTER //
// ./src/components/ui/AdPopup.js